import { getRealUrl, useCurrent } from '@maxtropy/components';
import React, { useEffect, useState, useRef } from 'react';
import styles from './index.module.scss';
import defaultHomeImg from '../../assets/image/defaultHome.jpg';
import { Subscription } from 'rxjs';
import { getSingleRxStompClient } from '@maxtropy/components';

const Home: React.FC = () => {
  const [homePageLogoUrl, setHomePageLogoUrl] = useState<string>();
  const current = useCurrent();
  const client = useRef(getSingleRxStompClient());

  useEffect(() => {
    const subscriptions: Subscription[] = [];
    if (current?.customerUser) {
      const subscription = client.current
        .watch(`/ws/dashboard/remote/${current?.customerUser.cellphone}`)
        .subscribe(value => {
          const commandValue = JSON.parse(value.body) as any;
          console.log('commandValue', value);
          if (commandValue?.commandUrl) {
            window.open(commandValue?.commandUrl, '_blank');
          }
        });

      subscriptions.push(subscription);
    }
    return () => subscriptions.forEach(subscription => subscription.unsubscribe());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  useEffect(() => {
    if (current?.staff) {
      setHomePageLogoUrl(current.staff.homePageLogoUrl);
    }
  }, [current]);

  return (
    <div className={styles.img}>
      <img
        className={styles.home}
        src={!!homePageLogoUrl ? getRealUrl(homePageLogoUrl) : defaultHomeImg}
        alt="首页图片"
      />
    </div>
  );
};

export default Home;
